import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   staffs:[]
}

const staffSlice = createSlice({
    name: "staff",
    initialState,
    reducers: {
        setstaff: (state, action) => {
            state.staffs = action.payload;
        },

      
       
    }
});

export const { setstaff} = staffSlice.actions;
export default staffSlice.reducer;